import { useContext } from "react";
import { EmailTemplateContext } from "../EmailTemplateContext";
import { ButtonElement } from "../elements/ButtonElement";
import { Divider } from "../elements/Divider";
import { Mailtext } from "../elements/Mailtext";
import { Plaintext } from "../elements/Plaintext";
import bell from "@/assets/images/email/bell.png";

export const TournamentConclusion = () => {
  const ctx = useContext(EmailTemplateContext);

  if (!ctx) return null;

  const {
    data,
    template: { template },
  } = ctx;

  return (
    <>
      <Plaintext template={template[1]!} innerRef={data.current[1]} />
      <Divider imageSrc={bell} />
      <ButtonElement template={template[2]!} innerRef={data.current[2]} />
      {template[3]?.text && (
        <>
          <Plaintext template={template[3]} innerRef={data.current[3]} />
          <Mailtext template={template[4]!} innerRef={data.current[4]} />
          <Plaintext template={template[5]!} innerRef={data.current[5]} />
          <Plaintext template={template[6]!} innerRef={data.current[6]} />
        </>
      )}
    </>
  );
};
